'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useLocaleSwitch } from '../../shared/useLocaleSwitch';

export const LocaleSwitchLink = () => {
  const { href, label, switchLocale } = useLocaleSwitch();
  return (
    <SlotEquivalentLinksItem href={href ?? '#'} onClick={switchLocale}>
      <span className="icon-emp-language-switch size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
